module.exports = __webpack_public_path__ + "img/svulp3.6e53c7e3.jpg";